import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/adobe-acrobat.svg'


_pushScopeId("data-v-6aa9553c")
const _hoisted_1 = { id: "modal-content" }
const _hoisted_2 = { id: "print-info" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Printing Tips", -1)
const _hoisted_4 = { id: "printing-tips" }
const _hoisted_5 = { class: "tip-wrap" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "tip-number" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1")
], -1)
const _hoisted_7 = { class: "tip-info" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Paper Size", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Select the correct paper size of ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" for your label sheet. ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "tip-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tip-number" }, [
    /*#__PURE__*/_createElementVNode("span", null, "2")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "tip-info" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Scale"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" Set the "),
      /*#__PURE__*/_createElementVNode("strong", null, "Scale"),
      /*#__PURE__*/_createTextVNode(" setting to "),
      /*#__PURE__*/_createElementVNode("strong", null, "100%"),
      /*#__PURE__*/_createTextVNode(" or "),
      /*#__PURE__*/_createElementVNode("strong", null, "Actual Size"),
      /*#__PURE__*/_createTextVNode(". Never print your labels at a Custom Scale, Fit to Page or using the Shrink Oversized Pages setting. ")
    ])
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "tip-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tip-number" }, [
    /*#__PURE__*/_createElementVNode("span", null, "3")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "tip-info" }, [
    /*#__PURE__*/_createElementVNode("h3", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Paper Weight")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" Set your printer's "),
      /*#__PURE__*/_createElementVNode("strong", null, "Paper Weight"),
      /*#__PURE__*/_createTextVNode(" or "),
      /*#__PURE__*/_createElementVNode("strong", null, "Media Type"),
      /*#__PURE__*/_createTextVNode(" to "),
      /*#__PURE__*/_createElementVNode("strong", null, "Labels"),
      /*#__PURE__*/_createTextVNode(" or the thickest settings available such as "),
      /*#__PURE__*/_createElementVNode("strong", null, "Heavyweight"),
      /*#__PURE__*/_createTextVNode(" or "),
      /*#__PURE__*/_createElementVNode("strong", null, "Cardstock"),
      /*#__PURE__*/_createTextVNode(". ")
    ])
  ])
], -1)
const _hoisted_13 = { id: "download-print" }
const _hoisted_14 = {
  key: 0,
  version: "1.1",
  id: "loader-1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "40px",
  height: "40px",
  viewBox: "0 0 50 50",
  style: {"enable-background":"new 0 0 50 50"},
  "xml:space": "preserve"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#ff6c00",
  d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
}, [
  /*#__PURE__*/_createElementVNode("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "rotate",
    from: "0 25 25",
    to: "360 25 25",
    dur: "2s",
    repeatCount: "indefinite"
  })
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { id: "recommendation" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" For the best results we recommend printing your labels in "),
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: "https://get.adobe.com/reader/"
    }, "Adobe Acrobat"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_18 = { id: "label-view" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", null, "Print Layout", -1)
const _hoisted_20 = { id: "modal-canvas-wrap" }
const _hoisted_21 = {
  ref: "modalCanvas",
  width: "350",
  height: "350"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        ref: "printPreviewRef",
        class: _normalizeClass(["modal-body", _ctx.bounceTransition])
      }, [
        (_ctx.clientDimensions.width > 767)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "close-svg",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, [
              _createVNode(_component_CloseSVG, {
                propId: 'print-close',
                fillColor: '#f7f9fc'
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("p", null, [
                    _hoisted_9,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.currentLabel.sheet_size_title), 1),
                    _hoisted_10
                  ])
                ])
              ]),
              _hoisted_11,
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_16))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    "aria-label": "Print Label",
                    class: "modal-print-btn",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.printSheet && _ctx.printSheet(...args)))
                  }, "Download & Print PDF"))
            ]),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            (_ctx.clientDimensions.width <= 767)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "close-svg",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, [
                  _createVNode(_component_CloseSVG, {
                    propId: 'print-close',
                    fillColor: '#f7f9fc'
                  })
                ]))
              : _createCommentVNode("", true),
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("canvas", _hoisted_21, null, 512)
            ]),
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              id: "edit-design"
            }, "Edit Your Design ›")
          ])
        ])
      ], 2)
    ], 2)
  ]))
}